export default __webpack_public_path__ + "static/media/call_direction_icon.7770335c.svg";